import React, { Component, Fragment, useEffect, useState } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import MetisMenu from 'react-metismenu';

import '@fortawesome/fontawesome-free/css/all.min.css';
import { navBarHelper } from '../../_helpers/navBarHelper';
import {  userService } from '../../_services/user.service';
import { api } from '../../_services/api.service';
import AppCache from '../../_helpers/appCache';

const MyNav = (props) => {

    const currentUser = userService.getLoggedInUser();
    let [nav, setNav] = useState([]);
    let [partnerId, setPartnerId] = useState(-1);
    let [partnerName, setPartnerName] = useState('');
    let webAppUrl = '';
    let observable = null;

    // let location = useLocation();

    // useEffect(() => {
    //     let nv = null;
    //     if (location.pathname.indexOf('partnersettings') > -1) {
    //         let list = location.pathname.split('/');
    //         setPartnerId(list[list.length - 1]);
    //         nv = navBarHelper.getNavigationBarByPathname(currentUser, location.pathname, list[list.length - 1]);
    //     } else {
    //         nv = navBarHelper.getNavigationBarByPathname(currentUser, location.pathname, partnerId);
    //     }
    //     setNav(nv);
    // }, [location])

    useEffect(() => {
        populateNavigationItems();

        api.getWebAppUrl().then(url => {
            webAppUrl = url;
        })

        observable = AppCache.partnerObservable.subscribe(val => {
            if (val !== undefined && val !== null) {
                setPartnerId(val.partnerId);
                setPartnerName(val.partnerName);
                setNav(navBarHelper.getNavigationBarByPartner(currentUser, val.partnerId, val.partnerName))
            } else {
                populateNavigationItems();
            }
        })

        return () => {
            observable.unsubscribe();
        }

    }, [])

    const populateNavigationItems = () => {
        let nv = navBarHelper.getNavigationBar(currentUser);
        setNav(nv);
    }

    const onClick = (e, props) => {

        if (props.hasSubMenu)
            props.toggleSubMenu(e);
        else {
            //handle redirect
            // if (props.label == 'Activity') {
            //     e && e.preventDefault();
            // }

            // if (currentUser.roleId !== 110 && props.to.indexOf('/partnersettings/') > -1) {
            //     e && e.preventDefault();
            //     return;
            // }
            if (props.label == 'Make Decisions') {
                e && e.preventDefault();
                if (webAppUrl !== '') {
                    window.location.href = webAppUrl;
                }
            }

            props.activateMe({
                newLocation: props.to,
                selectedMenuLabel: props.label,
            });
        }
    }

    return (
        <Fragment>
            <div style={{ marginTop: "50px" }}>
                <MetisMenu
                    content={nav}
                    activeLinkFromLocation
                    className="vertical-nav-menu"
                    iconNamePrefix=""
                    classNameStateIcon="pe-7s-angle-down"
                    LinkComponent={(props) => {
                        return (
                            <a className="metismenu-link" style={props.to.indexOf('partnersettings') > -1 && props.label !== 'Templates' ? { fontWeight: 'bolder', marginTop: '20px', paddingLeft: '10px' } : {}} href={props.to} onClick={(e) => onClick(e, props)} >
                                {props.children}
                            </a >
                        )

                    }}
                />
            </div>
            <div className="menu-footer">
                <p>
                    <i>Definitive Choice</i>
                </p>
            </div>
            {/* <div style={{ marginTop: '50px', textAlign: 'center' }} className="def-choice-moto">
                <div style={{ height: '2px', width: '100%', background: '#428AF8' }} />
                <p style={{ marginTop: '20px', color: '#ffffff' }}><i>Better Decisions <i className="fas fa-arrow-right"></i> Better Outcomes</i></p>
            </div> */}

        </Fragment>
    );
}

export default withRouter(MyNav);